<template>
    <div>
        <div class="episode_hint">
            <p>Серия {{ episode }}</p>
        </div>   
    </div>
</template>
    
    
    
<script>
import axios from 'axios';

    
export default {
    props: {
        episode: {
        type: String,
        required: true
        }
    },
    data() {
        return {
            originUrl: window.location.origin,
            title: "",
            watching_list: [],
            isMobile: false
        };
    },

    methods: {
        setWidthOfSimilar: function(){

        }
    }
    
};
</script>
    
<style scoped>
 
</style>